import { render, staticRenderFns } from "./Registru.vue?vue&type=template&id=25b3aa5b"
import script from "./Registru.vue?vue&type=script&lang=js"
export * from "./Registru.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports